'use client';
import LargeCarousel from '@/src/components/carousel/large-carousel';
import { useLocale } from 'next-intl';
import { IBanner } from '../services/types';
import Container from '@/src/components/ui/container';

export type CarouselSectionItem = {
  slides: IBanner[];
  branchId?: number;
};

const Banner = (props: CarouselSectionItem) => {
  const localActive = useLocale();

  return (
    <Container>
      <LargeCarousel
        branchId={props.branchId}
        slides={props.slides?.map((item) => ({
          image: localActive === 'ar' ? item.ArabicImage : item.EnglishImage,
          Destination: item.Destination,
        }))}
      />
    </Container>
  );
};

export default Banner;
